import { render } from "./Mentions.vue?vue&type=template&id=66358ddb&ts=true"
import script from "./Mentions.vue?vue&type=script&lang=ts"
export * from "./Mentions.vue?vue&type=script&lang=ts"

import "./Mentions.vue?vue&type=style&index=0&id=66358ddb&lang=css"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__